import React from "react";

const InnovativeAjangInovasi: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Perkembangan teknologi di era kecerdasan buatan (AI) dan otomasi telah mengubah cara 
        manusia bekerja, belajar, dan memecahkan masalah. Pemanfaatan AI, robotika, dan sistem 
        otomatis kini tidak lagi terbatas pada industri besar, tetapi juga merambah pendidikan, layanan 
        publik, dan kehidupan sehari-hari. Kondisi ini menuntut generasi muda memiliki kesiapan 
        teknologi yang lebih dari sekadar pemahaman teori, melainkan kemampuan berpikir adaptif, 
        analitis, dan solutif sejak dini.
      </p>

      <p>
        Menjawab tantangan tersebut, <strong>Innovative Technology Challenge</strong> hadir sebagai
        ajang kompetisi yang menempatkan inovasi teknologi sebagai sarana
        pembelajaran menghadapi masa depan. Kompetisi ini mendorong pelajar memahami cara kerja teknologi cerdas sekaligus 
        penerapannya dalam menjawab kebutuhan nyata masyarakat. Peserta ditantang merancang 
        solusi berbasis AI, otomasi, maupun sistem terintegrasi yang relevan dengan tantangan zaman 
        dan konteks kehidupan sehari-hari.
      </p>

      <p>
        Berbeda dari kompetisi teknologi konvensional, Innovative Technology
        Challenge menekankan pentingnya proses berpikir dan relevansi solusi,
        bukan semata-mata hasil akhir. Peserta diajak memahami tahapan perancangan sistem,
        pengambilan keputusan berbasis data, serta integrasi teknologi
        yang efisien. Pendekatan ini sejalan dengan kebutuhan{" "}
        <a
          href="https://www.weforum.org/stories/jobs-and-the-future-of-work/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          keterampilan masa depan
        </a>
        , di mana kemampuan problem solving, berpikir kritis, dan adaptasi teknologi 
        menjadi kunci utama di dunia kerja yang terus berkembang.
      </p>

      <p>
        Selain itu, kompetisi ini mengarahkan{" "}
        <a
          href="https://www.unesco.org/en/sustainable-development/education"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          inovasi peserta
        </a>{" "}
        agar selaras dengan{" "}
        <a
          href="https://sdgs.un.org/goals"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          17 Tujuan Pembangunan Berkelanjutan (Sustainable Development Goals/SDGs)
        </a>
        . Melalui pendekatan ini, teknologi diposisikan tidak hanya sebagai simbol kecanggihan,
        etapi juga sebagai solusi berkelanjutan bagi isu pendidikan, kesehatan, lingkungan, dan kesejahteraan sosial.
        Peserta didorong untuk melihat dampak sosial dari teknologi yang mereka kembangkan.
      </p>

      <p>
        Melalui platform <strong>Indonesia Innovative Technology (IIT)</strong>,
        yang didukung oleh{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , Innovative Technology Challenge menjadi ruang belajar yang memadukan 
        teknologi, kreativitas, dan kesiapan masa depan. Peserta tidak hanya mengasah kemampuan 
        teknis seperti pemrograman dan perancangan sistem, tetapi juga mengembangkan 
        keterampilan kolaborasi, komunikasi ide, dan berpikir strategis. Kompetisi ini menjadi langkah 
        awal pembentukan generasi muda yang siap berperan sebagai inovator dan agen perubahan di 
        era AI dan otomasi.
      </p>

      <p className="pt-4 font-medium">
        👉 Cek untuk informasi lomba{" "}
        <a
          href="/iit-program?program=Innovative"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          inovasi teknologi
        </a>{" "}
        lebih lanjut
      </p>
    </div>
  );
};

export default InnovativeAjangInovasi;
